function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable */
import { head, tail } from 'lodash';
import { EVENT_LOGGING } from './constants';

var local = window.location.host.match(/localhost/) || window.location.host.match(/127.0.0.1/);
var staging = window.location.host.match(/staging/);

var Event = function () {
  function Event(type) {
    _classCallCheck(this, Event);

    this.type = type;
  }

  Event.prototype.detect = function detect(fn, args) {
    !local ? fn.call() : EVENT_LOGGING && console.log(this.type, args);
    return new Provider().provide(this.type);
  };

  return Event;
}();

var Service = function (_Event) {
  _inherits(Service, _Event);

  function Service() {
    _classCallCheck(this, Service);

    return _possibleConstructorReturn(this, _Event.apply(this, arguments));
  }

  Service.prototype.log = function log() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    // make sure trackers are loaded
    return this[this.type](head(args), tail(args));
  };

  Service.prototype.google = function google(event, args) {
    if (!ga) return false;
    return this.detect(ga.bind(this, 'send', 'event', event, head(args).action, head(args).label), arguments);
  };

  Service.prototype.kissmetrics = function kissmetrics(event, args) {
    if (!_kmq) return false;
    return this.detect(_kmq.push.bind(this, [event].concat(args)), arguments);
  };

  Service.prototype.facebook = function facebook(event, args) {
    if (!fbq) return false;
    return this.detect(fbq.bind(this, 'track', event, args), arguments);
  };

  return Service;
}(Event);

var Provider = function () {
  function Provider() {
    _classCallCheck(this, Provider);

    this.service = null;
  }

  Provider.prototype.provide = function provide(type) {
    var service = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    this.type = type;
    this.service = new Service(type);

    if (service) return this.service;

    return this;
  };

  return Provider;
}();

export var Events = new Provider();


//////////////////
// WEBPACK FOOTER
// ../ui-utilities/es/events.js
// module id = 593
// module chunks = 4